import type {FC, PropsWithChildren, BaseSyntheticEvent, JSX} from 'react'
import {useEffect} from 'react'
import type {FieldValues} from 'react-hook-form'
import {useForm, FormProvider} from 'react-hook-form'

export const ErrorMessage: FC<{message: string}> = ({message}): JSX.Element => (
	<span className="flex items-center py-1 text-red-500">
		<svg
			className="inline-block fill-current"
			height="20"
			viewBox="0 0 27 27"
			width="20"
		>
			<path d="M13.3,26.8c-3.6,0-7-1.4-9.5-4c-2.5-2.5-4-6-4-9.5c0-3.6,1.4-7,4-9.5c2.5-2.5,6-4,9.5-4c3.6,0,7,1.4,9.5,4c2.5,2.5,4,6,4,9.5c0,3.6-1.4,7-4,9.5C20.3,25.4,16.8,26.8,13.3,26.8z M13.6,17.8c-0.7,0-1.4,0.2-1.9,0.6c-0.4,0.4-0.7,.1-0.7,1.7c0,0.6,0.2,1.2,0.7,1.7c0.5,0.4,1.2,0.6,1.9,0.6c0.7,0,1.3-0.2,1.8-0.6c0.5-0.4,0.7-1.1,0.7-1.7c0-0.6-0.2-1.2-0.6-1.7C14.9,18,14.2,17.8,13.6,17.8L13.6,17.8z M11,4.6L11,4.6l0.6,11.4h4l0.6-11.4H11z" />
		</svg>
		<span className="pl-2 !text-xs text-pet-primary">{message}</span>
	</span>
)

export interface FormProps {
	action: string
	className?: string
	ajaxSubmission?: boolean
	onSubmit?: (data: FieldValues) => void
	setFormField?: Record<string, unknown>
}

export const FormWrapper: FC<PropsWithChildren<FormProps>> = ({
	action,
	className = '',
	children,
	ajaxSubmission = false,
	onSubmit,
	setFormField = null,
}) => {
	const methods = useForm({
		mode: 'onBlur',
	})

	useEffect(() => {
		if (setFormField && Object.keys(setFormField).length > 0) {
			const key = Object.keys(setFormField)[0]
			const value = Object.values(setFormField)[0]
			if (key && value !== undefined) {
				methods.setValue(key, value)
			}
		}
	}, [methods, setFormField])

	const submitForm = (
		data: FieldValues,
		e: BaseSyntheticEvent | undefined
	): void => {
		if (onSubmit) {
			onSubmit(data)
		}
		if (!ajaxSubmission && e?.target instanceof HTMLFormElement) {
			e.target.submit()
		}
	}

	if (!children) return null

	return (
		<div className={className}>
			<FormProvider {...methods}>
				<form
					action={action}
					noValidate
					onSubmit={(e) => {
						e.preventDefault()
						void methods.handleSubmit((data) => {
							submitForm(data, e)
						})()
					}}
				>
					{children}
				</form>
			</FormProvider>
		</div>
	)
}
